var map = {
	"./flag_de.svg": "acb7",
	"./flag_en.svg": "7bcc",
	"./flag_es.svg": "7d39",
	"./flag_fr.svg": "5132",
	"./flag_it.svg": "4d4f",
	"./flag_pt.svg": "cd8c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0040";